import { CampaignPerformanceRoot, ScreenRoot } from "types";

export const CampaignPerformanceRootDefinition: ScreenRoot = {
  name: CampaignPerformanceRoot,
  routePath: ["/campaign-pacing/*"],
  accessPath: "digitalForecasting",
};
